export default __webpack_public_path__ + "static/media/OpenSansRegular.f8154774.woff";